var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsQuestionmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57812 0.652344C7.32812 0.652344 8.75 2.04688 8.75 3.79688C8.75 5 8.06641 6.09375 7 6.64062L4.8125 7.92578V8.5C4.8125 8.99219 4.40234 9.375 3.9375 9.375C3.44531 9.375 3.0625 8.99219 3.0625 8.5V7.40625C3.0625 7.10547 3.19922 6.83203 3.47266 6.66797L6.15234 5.10938C6.69922 4.83594 7 4.34375 7 3.79688C7 3.03125 6.34375 2.40234 5.57812 2.40234H2.625C2.13281 2.40234 1.75 2.78516 1.75 3.27734C1.75 3.71484 1.33984 4.125 0.875 4.125C0.382812 4.125 0 3.74219 0 3.27734C0 1.82812 1.17578 0.652344 2.625 0.652344H5.57812ZM3.9375 10.6875C4.53906 10.6875 5.03125 11.207 5.03125 11.7812C5.03125 12.3828 4.53906 12.875 3.9375 12.875C3.30859 12.875 2.84375 12.4102 2.84375 11.7812C2.84375 11.1797 3.30859 10.6875 3.9375 10.6875Z",
    fill: "#AAB4BE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsQuestionmark);
export default __webpack_public_path__ + "static/media/icons_questionmark.55184cdd.svg";
export { ForwardRef as ReactComponent };